import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { useEffect, useRef, useState } from 'react'
import { IBrand } from '../../../../../../../app/entities/Brand'
import { ICustomer } from '../../../../../../../app/entities/Customer'
import { ICustomerVehicle } from '../../../../../../../app/entities/CustomerVehicle'
import { IInstallationPoint } from '../../../../../../../app/entities/InstallationPoint'
import { IOrder } from '../../../../../../../app/entities/Order'
import { Tire } from '../../../../../../../app/entities/Tire'
import { TiresCombination } from '../../../../../../../app/entities/TiresCombination'
import PrimaryButton from '../../../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../../../global/components/buttons/secondary-button/SecondaryButton'
import { AppointmentSlots } from '../appointment-slot/AppointmentSlots'
import { OrderDetails } from '../order-details/OrderDetails'
import { ConfirmAppointment } from '../confirm-appointment/ConfirmAppointment'

import { CustomerInformation } from '../customer-information/CustomerInformation'
import { TireSizeQuantity } from '../size-quantity/TireSizeQuantity'
import styles from './styles.module.css'
import { MODES } from '../../../../../global/constants/scheduler'
interface IScheduleModalProps {
  isOpen: boolean
  handleClosed: Function
  chosenAddress: google.maps.GeocoderResult | null
  locationId: string
}

export interface ITiresCombinationWithPartialTire
  extends Omit<TiresCombination, 'frontTire | rearTire'> {
  frontTire: Partial<Tire> | any
  rearTire: Partial<Tire> | any
}

interface ICustomerVehicleWithPartialBrand
  extends Omit<ICustomerVehicle, 'brand'> {
  brand: Partial<IBrand> | any
}

export interface ISchedulerStateProps {
  customer: Partial<ICustomer>
  customerVehicle: Partial<ICustomerVehicle>
  order: Partial<IOrder>
  tiresCombination: Partial<ITiresCombinationWithPartialTire>
  installationPoint: Partial<IInstallationPoint>
  selectedTimes: number[]
  isRework: boolean
}

export const initialCustomerInfoProps: Partial<ICustomer> = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
}

export const initialInstallationPointProps: Partial<IInstallationPoint> = {
  city: '',
  state: '',
  zipCode: '',
  address: '',
  aptOrSuite: '',
}

export const initialCustomerVehicleProps: Partial<ICustomerVehicleWithPartialBrand> =
  {
    brand: {
      name: undefined,
      objectId: undefined,
    },
    model: '',
    year: '',
    variant: '',
  }

export const initialOrderProps: Partial<IOrder> = {
  salesRepresentativeNumber: '',
  tireSource: '',
  orderSource: '',
  note: '',
}

export const initialTiresCombinationProps: Partial<ITiresCombinationWithPartialTire> =
  {
    frontCount: 2,
    rearCount: 2,
    frontTire: {
      aspectRatio: '',
      width: '',
      diameter: '',
      psi: '',
      torque: '',
      manufacturer: '',
      model: '',
    },
    rearTire: {
      aspectRatio: '',
      width: '',
      diameter: '',
      psi: '',
      torque: '',
      manufacturer: '',
      model: '',
    },
  }

const routes = [
  { title: 'Select an Appointment Slot', path: 'appointment-slots' },
  { title: 'Customer Information', path: 'customer-info' },
  { title: 'Tire Size & Quantity', path: 'size-quantity' },
  { title: 'Order Details', path: 'order-details' },
  { title: 'Confirm Appointment Information', path: 'confirm-appointment' },
  { title: 'Customer Information', path: 'customer-info' },
  { title: 'Tire Size & Quantity', path: 'size-quantity' },
  { title: 'Select an Appointment Slot', path: 'appointment-slots' },
  { title: 'Payment Information', path: 'payment-information' },
  { title: 'Confirm Appointment Information', path: 'confirm-appointment' },
]

export default function ScheduleModal(props: IScheduleModalProps) {
  const [routeIndex, setRouteIndex] = useState(0)
  const [nextDisabled, setNextDisabled] = useState(true)
  const [forwardButtonCopy, setForwardButtonCopy] = useState('Next')

  const [selectedTimes, setSelectedTimes] = useState<number[]>([])
  const [customer, setCustomer] = useState<Partial<ICustomer>>(
    initialCustomerInfoProps,
  )
  const [installationPoint, setInstallationPoint] = useState<
    Partial<IInstallationPoint>
  >(initialInstallationPointProps)
  const [customerVehicle, setCustomerVehicle] = useState<
    Partial<ICustomerVehicle>
  >(initialCustomerVehicleProps)
  const [tiresCombination, setTiresCombination] = useState<
    Partial<ITiresCombinationWithPartialTire>
  >(initialTiresCombinationProps)
  const [order, setOrder] = useState<Partial<IOrder>>(initialOrderProps)
  const [isRework, setIsRework] = useState(false)
  const [disposalCount, setDisposalCount] = useState(0)

  const { chosenAddress, handleClosed, locationId } = props

  const ref = useRef<any>(null)

  const forwardClick = () => {
    if (ref.current !== null) {
      ref.current.useNextClick((forward: boolean) => {
        if (forward) {
          const newRouteIndex = routeIndex + 1
          setRouteIndex(newRouteIndex)
        }
      })
    }
  }

  const backClick = () => {
    setForwardButtonCopy('Next')
    const newRouteIndex = routeIndex - 1
    setRouteIndex(newRouteIndex)
  }

  const renderComponent = (path: string) => {
    switch (path) {
      case 'appointment-slots':
        return (
          <AppointmentSlots
            selectedTimes={selectedTimes}
            setSelectedTimes={setSelectedTimes}
            setDisabled={setNextDisabled}
            ref={ref}
            chosenAddress={props.chosenAddress}
            setInstallationPoint={setInstallationPoint}
            mode={MODES.SCHEDULER}
            locationId={locationId}
          />
        )
      case 'customer-info':
        return (
          <CustomerInformation
            customer={customer}
            setCustomer={setCustomer}
            installationPoint={installationPoint}
            setInstallationPoint={setInstallationPoint}
            customerVehicle={customerVehicle}
            setCustomerVehicle={setCustomerVehicle}
            setDisabled={setNextDisabled}
            ref={ref}
            chosenAddress={chosenAddress}
            mode={MODES.SCHEDULER}
            location={order.location}
          />
        )
      case 'size-quantity':
        return (
          <TireSizeQuantity
            customerVehicle={customerVehicle}
            tiresCombination={tiresCombination}
            setTiresCombination={setTiresCombination}
            disposalCount={disposalCount}
            setDisposalCount={setDisposalCount}
            ref={ref}
            setDisabled={setNextDisabled}
          />
        )
      case 'order-details':
        return (
          <OrderDetails
            order={order}
            setOrder={setOrder}
            isRework={isRework}
            setIsRework={setIsRework}
            ref={ref}
            setDisabled={setNextDisabled}
            setForwardButtonCopy={setForwardButtonCopy}
            chosenAddress={chosenAddress}
            installationPoint={installationPoint}
            locationId={locationId}
          />
        )
      case 'confirm-appointment':
        return (
          <ConfirmAppointment
            customer={customer}
            installationPoint={installationPoint}
            customerVehicle={customerVehicle}
            tiresCombination={tiresCombination}
            order={order}
            selectedTimes={selectedTimes}
            isRework={isRework}
            disposalCount={disposalCount}
            ref={ref}
            handleClosed={handleClosed}
            setForwardButtonCopy={setForwardButtonCopy}
            locationId={locationId}
          />
        )
    }
  }
  const resetState = () => {
    setSelectedTimes([])
    setCustomer(initialCustomerInfoProps)
    setInstallationPoint(initialInstallationPointProps)
    setCustomerVehicle(initialCustomerVehicleProps)
    setOrder(initialOrderProps)
    setTiresCombination(initialTiresCombinationProps)
    setIsRework(false)
    setDisposalCount(0)

    setRouteIndex(0)
    setNextDisabled(true)
    setForwardButtonCopy('Next')
  }
  useEffect(() => {
    if (!props.isOpen) {
      resetState()
    }
  }, [props.isOpen])

  return (
    <div>
      <Modal
        open={props.isOpen}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className={styles.scheduleModal}>
          <div className={`${styles.scheduleModalPageTitle} font--bold`}>
            {routes[routeIndex].title}
          </div>
          <div
            style={{ maxHeight: '100%', width: '100%', overflowX: 'scroll' }}
          >
            {renderComponent(routes[routeIndex].path)}
          </div>
          <div className={styles.buttonContainer}>
            <div className={styles.flexGroupButtons}>
              {['Next', 'Confirm'].includes(forwardButtonCopy) && (
                <>
                  <SecondaryButton
                    disabled={routeIndex === 0}
                    buttonName='Back'
                    onClick={backClick}
                  />
                  <PrimaryButton
                    buttonName='Cancel'
                    onClick={() => props.handleClosed()}
                  />
                </>
              )}
            </div>
            <PrimaryButton
              disabled={nextDisabled}
              buttonName={forwardButtonCopy}
              onClick={forwardClick}
            />
          </div>
        </Box>
      </Modal>
    </div>
  )
}
